import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { isInApp } from 'utils'
import styles from './PublicLayout.module.scss'
import ErrorBoundary from 'components/ErrorBoundary'
import Loader from 'components/Loader'

const WidgetLayout = lazy(() => import('exporterLayout/Layout'))

const PublicWrapper = (PublicComponent, hasNavBarMargin = true) => (
  <PublicLayout hasNavBarMargin={hasNavBarMargin}>
    <PublicComponent />
  </PublicLayout>
)

const PublicLargeWrapper = (PublicComponent, props, hasNavBarMargin = true) => (
  <PublicLayout size='large' hasNavBarMargin={hasNavBarMargin}>
    <PublicComponent {...props} />
  </PublicLayout>
)

const PublicFullscreenWrapper = (PublicComponent, props) => (
  <PublicLayout size='fullscreen'>
    <PublicComponent {...props} />
  </PublicLayout>
)

const WrapperChildren = ({ children, size, hasNavBarMargin }) => {
  const baseStyles = ` ${size ? styles[`content-${size}`] : ''}  ${
    !hasNavBarMargin ? styles['hasNoMargin'] : ''
  } ${styles.content}`

  return (
    <div className={baseStyles}>
      <div>{children}</div>
    </div>
  )
}

const PublicLayout = ({ children, size, hasNavBarMargin }) => (
  <section className={styles.page}>
    <section className={styles.main}>
      {!isInApp() ? (
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <WidgetLayout
              service='onboarding'
              menuURL={process.env.REACT_APP_PLURALL_MENU_API_URL}
              graphqlURL={process.env.REACT_APP_SOMOS_GRAPHQL_URL}
              isUnauthenticated
              hideNavBar
              hideGlobalMenu
            >
              <WrapperChildren size={size} hasNavBarMargin={hasNavBarMargin}>
                {children}
              </WrapperChildren>
            </WidgetLayout>
          </Suspense>
        </ErrorBoundary>
      ) : (
        <WrapperChildren size={size} hasNavBarMargin={hasNavBarMargin}>
          {children}
        </WrapperChildren>
      )}
    </section>
  </section>
)

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  hasNavBarMargin: PropTypes.bool,
}

export { PublicFullscreenWrapper, PublicLargeWrapper, PublicLayout, PublicWrapper }
